module.exports = __webpack_public_path__ + "static/media/empty.09789c77.svg";